// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './CodeBlock.module.css';

/**
 * CodeBlock component - Displays preformatted code in a scrollable block
 * @param {object} props
 * @param {string} props.code - Code to display (already formatted)
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element}
 */
function CodeBlock({ code, className }) {
  return (
    <pre className={cn([styles['code-block'], ...(className ? [className] : [])])}>
      <code>{code}</code>
    </pre>
  );
}

export default CodeBlock;
